export const theme = {
  optionDescriptionRendererColor: Styles.color.grey.one,
  sectionDescriptionRendererColor: Styles.color.grey.one,
};
